/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimCenterBookable
 */
export interface ClaimCenterBookable {
    /**
     * 
     * @type {number}
     * @memberof ClaimCenterBookable
     */
    sortOrder: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterBookable
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterBookable
     */
    claimCenterId: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterBookable
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterBookable
     */
    id: string;
}

/**
 * Check if a given object implements the ClaimCenterBookable interface.
 */
export function instanceOfClaimCenterBookable(value: object): value is ClaimCenterBookable {
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('claimCenterId' in value) || value['claimCenterId'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function ClaimCenterBookableFromJSON(json: any): ClaimCenterBookable {
    return ClaimCenterBookableFromJSONTyped(json, false);
}

export function ClaimCenterBookableFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimCenterBookable {
    if (json == null) {
        return json;
    }
    return {
        
        'sortOrder': json['sortOrder'],
        'name': json['name'],
        'claimCenterId': json['claimCenterId'],
        'customerId': json['customerId'],
        'id': json['id'],
    };
}

export function ClaimCenterBookableToJSON(value?: ClaimCenterBookable | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sortOrder': value['sortOrder'],
        'name': value['name'],
        'claimCenterId': value['claimCenterId'],
        'customerId': value['customerId'],
        'id': value['id'],
    };
}

